import { GET_BIKE_MODEL_VARIANTS_REQUEST, GET_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, GET_BIKE_MODEL_VARIANTS_REQUEST_FAILURE } from '../constants/bike_model_variants.constants';

const prefix = 'GET';
export const getBikeModelVariantsRequest = model_id => ({
    type: GET_BIKE_MODEL_VARIANTS_REQUEST, model_id, prefix,
});

export const getBikeModelVariantsRequestSuccess = variants => ({
    type: GET_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, variants, prefix,
});

export const getBikeModelVariantsRequestFailure = error => ({
    type: GET_BIKE_MODEL_VARIANTS_REQUEST_FAILURE, error, prefix,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/actions/get_bike_model_variants.actions.js